/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import _sortBy from 'lodash.sortby';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';

import DS from 'ember-data';
import ApiErrorsService from 'cio/services/api-errors';
import NewsletterModel from 'cio/models/newsletter';
import TemplateModel from 'cio/models/template';
import { getDefaultTemplates } from 'cio/utils/newsletter-testgroups';
import orderBy from 'lodash.orderby';

const SPLIT_LIMIT = 8;

interface TemplateListArgs {
  newsletter: NewsletterModel;
  canAddTemplate: boolean;
  didAddTemplate: (template: TemplateModel) => unknown;
  didDeleteTemplate: () => unknown;
}

export default class TemplateList extends Component<TemplateListArgs> {
  @service apiErrors!: ApiErrorsService;
  @service store!: DS.Store;

  @tracked lastAddedTemplate!: TemplateModel;

  get addVariationDisabled() {
    let variations = getDefaultTemplates(this.args.newsletter.templates.content as TemplateModel[]);
    return variations.length >= SPLIT_LIMIT;
  }

  get isAddingVariation() {
    return this.addVariationTask.isRunning;
  }

  get templates() {
    return orderBy(this.args.newsletter.testVariations, (variation) => Number(variation.testGroupId));
  }

  addVariationTask = task({ drop: true }, async () => {
    try {
      await this.args.newsletter.addTestGroup({});

      let lastTemplate = _sortBy(this.args.newsletter.testVariations, ['created']).lastObject;

      if (lastTemplate !== undefined) {
        this.args.didAddTemplate(lastTemplate);
        this.lastAddedTemplate = lastTemplate;
      }
    } catch (errors) {
      this.apiErrors.report(errors);
    }
  });

  _deleteVariation = task({ drop: true }, async (template: TemplateModel) => {
    try {
      await this.args.newsletter.deleteTestGroup(template.testGroupId);
      this.args.didDeleteTemplate();
    } catch (errors) {
      this.apiErrors.report(errors);
      template.rollbackAttributes();
    }
  });
}
